import { Navigate, Outlet } from 'react-router-dom';
import { useIsAdmin } from '@/hooks/useAdmin';
import LoadingPage from '@/components/ui/LoadingPage';

/**
 * The mirror of {@link AdminRoute}: the clinic app is a different product from the admin
 * console, so an admin does not fall through into it. Everything an admin needs about a
 * case is in the console's own case panel.
 *
 * Waiting for the profile matters here for the same reason it does on the admin side —
 * routing on a not-yet-known role would flip the user between viewports on every reload.
 */
export function ClinicRoute() {
  const { isAdmin, isLoading } = useIsAdmin();

  if (isLoading) {
    return <LoadingPage />;
  }

  if (isAdmin) {
    return <Navigate to="/admin" replace />;
  }

  return <Outlet />;
}
